import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import React, { ReactElement } from 'react'
import { colors } from '@lib/colors'

interface CardProps {
  children: ReactElement | ReactElement[]
  style?: StyleProp<ViewStyle>
}

interface Styles {
  card: ViewStyle
}

export default function ({ children, style = {} }: CardProps) {
  return (
    <View style={StyleSheet.compose(styles.card, style)}>
      { children }
    </View>
  )
}

const styles = StyleSheet.create<Styles>({
  card: {
    backgroundColor: colors.white,
    padding: 20,
    borderRadius: 3,
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 5,
    width: '100%',
  },
})
